import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
//import Avatar from '@material-ui/core/Avatar';
import {
  CalendarToday,
  School,
  EmojiPeople
} from '@material-ui/icons';

import Image from '../components/Image';
import piano from '../images/piano.jpg';
import julie from '../images/julie.jpg';

const styles = theme => ({
  white: {
    color: theme.palette.common.white
  },
  container: {
    padding: 20
  },
  flex: {
    flex: 1
  },
  bar: {
    padding: 10,
  },
  banner: {
    backgroundImage: `url(${piano})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: 585,
    position: 'relative',
    borderBottom: '4px solid',
    borderBottomColor: theme.palette.secondary.main
  },
  bannerText: {
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    opacity: 0.8,
    height: 200,
    top: 200,
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.up('sm')]: {
      width: 500
    },
  },
  bannerTitle: {
    textAlign: 'center',
    color: theme.palette.secondary.main,
    fontFamily: 'Signika, Roboto, Arial',
    fontWeight: 'bold',
    fontSize: 40
  },
  bannerSummary: {
    textAlign: 'center',
    color: theme.palette.common.white,
    fontFamily: 'Signika, Roboto, Arial',
    fontWeight: 300,
    fontSize: 21,
    marginTop: 20
  },
  bannerCaption: {
    textAlign: 'center',
    color: theme.palette.common.white,
    fontFamily: 'Signika, Roboto, Arial',
    fontWeight: 300,
    fontSize: 16,
  },
  statement: {
    padding: 20
  },
  centered: {
    textAlign: 'center'
  },
  icon: {
    color: theme.palette.primary.main,
    margin: 20,
    width: 70,
    height: 70
  },
  intro: {
    padding: 20,
    background: theme.palette.grey.background,
    flexGrow: 1,
  },
  spacing: {
    margin: '20px 0',
    padding: '20px 0',
  },
  mission: {
    color: theme.palette.primary.main,
    fontFamily: 'Signika, Roboto, Arial',
    fontWeight: 'bold',
    fontSize: 40
  },
  divider: {
    borderRightColor: theme.palette.primary.main
  },
  avatar: {
    marginLeft: 150,
    width: 400,
    height: 400,
  }
});

class Home extends Component {

    goToContact = () => {
        this.props.history.push('/contact');
    }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.banner}>
          <div className={classes.bannerText}>
            <Typography className={classes.bannerTitle} variant="h4">
              Music Classes
            </Typography>
            <Typography className={classes.bannerSummary} variant="h6">
                Offering Virtual and In-Person classes
            </Typography>
            <Typography className={classes.bannerCaption} variant="h6">
                (In-Person classes offered in Cooper City, FL)
            </Typography>
          </div>
        </div>

        <div className={classes.statement}>
          <Grid container
            direction="row"
            alignItems="center"
            justifyContent="center"
            className={classes.spacing}
          >
            <Grid item xs={12} md={8}>

              <Grid container
                spacing={2}
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item xs={12} md={6} className={classes.divider}>
                  <Typography className={classes.mission} variant="h5">
                    Our Vision
                  </Typography>
                  <Typography variant="subtitle1" >
                    We believe that music instruction should be enjoyable, built on a solid technical foundation,
                    inspire creativity, and match each individual's goals. <br/><br/>
                    Learning an instrument — like the piano, for instance — has many proven benefits.
                    Playing music both assists in children's development and enriches the lives of adults.
                  </Typography>
                  <div className={classes.spacing}>
                  <Typography className={classes.mission} variant="h5">
                    Our Mission
                  </Typography>
                  <Typography variant="subtitle1">
                  Dr. Julie has developed an adaptive instructional system to support individual students with
                  uniquely different learning and cognitive styles. She has 24 years of experience working with
                  individuals of all ages with different musical ability, as well as individuals with varying
                  exceptionalities (e.g., Autism Spectrum). She has created four successful sequential programs to
                  serve diverse students from age 3 to adult. <br/><br/>

                    Students will acquire a foundation of classical piano by building a varied repertoire of music
                  representing the baroque, classical, romantic and contemporary periods. Students will learn piano
                  technique and theory through weekly lessons. Through piano study, students develop auditory
                  skills, timing and rhythm, sight reading, and memorization skills, which will create well-rounded
                  pianists. Many former students have auditioned and been accepted at competitive middle school,
                  high school, and college music programs, both locally and nationally.
                  </Typography>
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Hidden smDown>
                    <Image src={julie} alt="Julie" width="80%" />
                  </Hidden>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        </div>

        <div className={classes.intro}>
          <Grid container
            direction="row"
            alignItems="center"
            justifyContent="center"
            className={classes.spacing}
          >
            <Grid item xs={12} sm={8}>

              <Grid container
                direction="row"
                alignItems="center"
                justify="space-between"
                spacing={4}
              >
                <Grid item xs={12} sm={4} className={classes.centered}>
                  <School className={classes.icon} />
                  <Typography className={classes.mission} variant="h5">
                    Anyone Can Learn
                  </Typography>
                  <Typography variant="subtitle1" className={classes.spacing}>
                    We teach anyone from age 3 on.
                    We guide each and every student through the basics of reading and playing music.
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={4} className={classes.centered}>
                  <EmojiPeople className={classes.icon} />
                  <Typography className={classes.mission} variant="h5">
                    Gardiner Scholarship
                  </Typography>
                  <Typography variant="subtitle1" className={classes.spacing}>
                    Musicology Studio, Inc is a state-approved provider for the Gardiner Special Needs Scholarship.
                    This scholarship can be used for specialized music therapy services.
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={4} className={classes.centered}>
                  <CalendarToday className={classes.icon}/>
                  <Typography className={classes.mission} variant="h5">
                    Schedule A Lesson
                  </Typography>
                  <Typography variant="subtitle1" className={classes.spacing}>
                    We want to hear from you! Please contact us with any questions and to
                    <Button color="primary" onClick={this.goToContact}>schedule your trial lesson</Button>
                  </Typography>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Home);
